// @ts-nocheck
import React, { useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import FormFileUpload from '../../common/FormFileUpload';
import KwPanel from '../../common/KwPanel';
import { useForm } from 'react-hook-form';
import FormInput from '../../common/FormInput';
import FormStatic from '../../common/FormStatic';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { uploadKeys } from '../../../api/requestApi';

export interface UploadKeysProps {
  done: (result?: { id?: string }) => void;
  cancel: () => void;
  requestId: string;
  gameName: string;
  skuName: string;
  keyProviderName: string;
  numberOfKeys: number;
  requesterTag?: string;
  packageId?: string;
  file?: File | null;
}

function UploadKeys({
  done,
  cancel,
  requestId,
  gameName,
  skuName,
  keyProviderName,
  packageId,
  numberOfKeys,
  requesterTag,
  file,
}: UploadKeysProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [keys, setKeys] = useState<{ file?: File | null }>({ file: file ?? null });
  const addFiles = (files: File[]) => {
    setKeys((k) => ({ ...k, file: files[0] }));
  };
  const onSubmit = (data: any) => {
    uploadKeys(requestId, { ...keys, ...data })
      .then(({ id }: { id?: string }) => {
        toast.success(t('Keys successfully uploaded to be processed'));
        done({ id });
      })
      .catch(() => {
        toast.error(t('Failed to upload keys'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Upload to request')}
      cancel={cancel}
      bar={
        <input
          type="submit"
          value={t('Upload')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <KwPanel className="mb-4">
        <FormStatic label={t('Game')}>{gameName}</FormStatic>
        <FormStatic label={t('SKU')}>{skuName}</FormStatic>
        <FormStatic label={t('Provider')}>{keyProviderName}</FormStatic>
        {packageId && (
          <FormStatic label={t('Package Id')}>{packageId}</FormStatic>
        )}
        <FormStatic label={t('Number of keys')}>{numberOfKeys}</FormStatic>
        <FormStatic label={t('Requester tag')}>{requesterTag}</FormStatic>
        <FormInput
          register={register}
          name="tag"
          label={t('Tag')}
          placeholder={t('Optional')}
          autoFocus={true}
        />
        <FormFileUpload
          name="files"
          required
          errorMessage={t('Required')}
          label={t('Upload key file')}
          error={errors.files}
          addFiles={addFiles}
          removeFile={() => setKeys((k) => ({ ...k, file: null }))}
          files={keys.file ? [keys.file] : []}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default UploadKeys;
